import { easings, useSpring } from '@react-spring/web';

type Args<T> = {
  rewardConfig?: T | null;
  previousRewardConfig?: T | null;
};
export const useSwitchRewardSpring = <T extends { id: string }>({
  rewardConfig,
  previousRewardConfig,
}: Args<T>) => {
  const animate =
    !!previousRewardConfig &&
    !!rewardConfig &&
    previousRewardConfig.id !== rewardConfig.id;

  const [{ y }] = useSpring(
    () => ({
      from: {
        y: 0,
      },
      to: {
        y: animate ? 105 : 0,
      },
      config: {
        duration: 2500,
        easing: easings.easeOutCubic,
      },
      reset: true,
    }),
    [animate]
  );

  return {
    animate,
    y,
  };
};
